import { render, staticRenderFns } from "./BatchEditImages.vue?vue&type=template&id=5f2b3002&scoped=true"
import script from "./BatchEditImages.vue?vue&type=script&lang=js"
export * from "./BatchEditImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2b3002",
  null
  
)

export default component.exports